import { atom } from 'jotai';

export const showCreateUploadTaskPanelAtom = atom<boolean>(false);
